import React, { useState, useEffect } from "react";
import Helmet from "../../components/Helmet";
import { Link } from "react-router-dom";
import AdminLayout from "../../layouts/AdminLayout";
import api from "../../api/axiosInstance";

const DashboardStatCard = ({ title, count, icon, gradient }) => {
  const [displayCount, setDisplayCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = count;
    const duration = 1200; // animation duration (ms)
    const incrementTime = 20;
    const step = Math.ceil(end / (duration / incrementTime));

    const timer = setInterval(() => {
      start += step;
      if (start >= end) {
        setDisplayCount(end);
        clearInterval(timer);
      } else {
        setDisplayCount(start);
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [count]);

  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div className="stat-card" style={{ background: gradient }}>
        <div className="stat-card-body">
          <div className="stat-text">
            <h6>{title}</h6>
            <h2>{displayCount.toLocaleString()}</h2>
          </div>

          <div className="stat-icon">
            <i className={`bi ${icon}`}></i>
          </div>
        </div>
      </div>
    </div>
  );
};

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    formSubmitted: 0,
    verifiedUsers:0,
    approvedUsers: 0,
    discrepencyUsers: 0,
    rejectedUsers: 0,
    pendingUsers: 0,
  });
  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const res = await api.get("/admin/dashboard");

        setStats({
          totalUsers: res.data.data.TOTAL_USERS,
          formSubmitted: res.data.data.SUBMITTED_USERS,
          verifiedUsers: res.data.data.VERIFIED_USERS,
          approvedUsers: res.data.data.APPROVED_USERS,
          discrepencyUsers: res.data.data.DISCREPENCY_USERS,
          rejectedUsers: res.data.data.REJECTED_USERS,
        });
      } catch (err) {
        console.error("Dashboard fetch failed", err);
      }
    };

    fetchDashboard();
  }, []);

  return (
   <div className="container-fluid mt-3">
  <div className="row">
    <DashboardStatCard
      title="Total Login Users"
      count={stats.totalUsers}
      icon="bi-people-fill"
      gradient="linear-gradient(135deg, #2563eb, #60a5fa)"
    />

    <DashboardStatCard
      title="Form Submitted"
      count={stats.formSubmitted}
      icon="bi-file-earmark-check-fill"
      gradient="linear-gradient(135deg, #0891b2, #67e8f9)"
    />

    <DashboardStatCard
      title="Verified"
      count={stats.verifiedUsers}
      icon="bi-patch-check-fill"
      gradient="linear-gradient(135deg, #059669, #6ee7b7)"
    />

    <DashboardStatCard
      title="Approved"
      count={stats.approvedUsers}
      icon="bi-check-circle-fill"
      gradient="linear-gradient(135deg, #15803d, #86efac)"
    />

    <DashboardStatCard
      title="Discrepancy"
      count={stats.discrepencyUsers}
      icon="bi-exclamation-triangle-fill"
      gradient="linear-gradient(135deg, #d97706, #fcd34d)"
    />

    <DashboardStatCard
      title="Rejected"
      count={stats.rejectedUsers}
      icon="bi-x-circle-fill"
      gradient="linear-gradient(135deg, #dc2626, #fca5a5)"
    />
  </div>
</div>
  );
};

export default AdminDashboard;
